import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

const HomeRoute = () => {
    const { isLoggedIn } = useAuth()
    return isLoggedIn ? <Navigate to={'/dashboard'} /> : <Navigate to={'/login'} />
}

export default HomeRoute
